import { z } from "zod";
import { SectionSpacingSchema } from "../../../../../zod/shared-schemas.mjs";
const HeroSectionBannerSchema = z.object({
  data: z.object({
    id: z.string().optional(),
    text: z.string().optional(),
    image: z.string().optional(),
    title: z.string().optional(),
    button: z.object({
      link: z.string().optional(),
      text: z.string(),
      target: z.enum(["_blank", "_self"]).optional(),
      isVisible: z.literal(true).optional()
      // isVisible может быть только true
    }).optional(),
    imageMobile: z.string().optional()
  }).merge(SectionSpacingSchema)
});
export default HeroSectionBannerSchema;
